import React, { useEffect } from "react";
import { Box, CircularProgress, Link, Typography } from "@mui/material";

/**
 * The vendor experience (registration + panel) lives on its own origin at
 * vendor.simplerhome.us. This route used to render the registration form
 * inline; it now redirects, so the form has exactly ONE home and the two
 * copies can't drift apart.
 *
 * Kept as a redirect rather than deleted because /vendor/register shipped
 * publicly on the main site, so any existing link must keep working.
 */
const VENDOR_PORTAL =
  process.env.REACT_APP_VENDOR_PORTAL_URL || "https://vendor.simplerhome.us";

const VendorRegisterRedirect: React.FC = () => {
  useEffect(() => {
    // `replace` so the back button returns to the referring page rather
    // than bouncing through this redirect again.
    window.location.replace(`${VENDOR_PORTAL}/register`);
  }, []);

  return (
    <Box sx={{ py: 10, textAlign: "center" }}>
      <CircularProgress sx={{ color: "#004B4C" }} />
      <Typography sx={{ mt: 2, color: "text.secondary" }}>
        Taking you to the SimplerHome vendor portal…
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        <Link href={`${VENDOR_PORTAL}/register`} sx={{ color: "#004B4C" }}>
          Continue to {VENDOR_PORTAL.replace(/^https?:\/\//, "")}
        </Link>
      </Typography>
    </Box>
  );
};

export default VendorRegisterRedirect;
